import React, { memo, useCallback, useContext, useRef, useState } from "react";
import { CustomListSubheader, ExtraSmallButton, NonInteractiveTooltip } from "../../custom";
import { AppContext } from "../../../App";
import { Menu, MenuItem, Stack } from "@mui/material";
import { MULTIPANE_FULLSCREEN_MODE_ID } from "../../../assets/constants";
import { selectMultiPaneFullScreen } from "../../../selectors/common";
import { useSelector } from "react-redux";

const replaySpeeds = [5, 2, 1, 0.5, 0.2]

const ReplaySpeedMenu: React.FC = () => {

    const [speed, setSpeed] = useState(1)

    const appContext = useContext(AppContext);
    const anchorRef = useRef<HTMLButtonElement>(null);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const container = useSelector(selectMultiPaneFullScreen)
    const replayManager = appContext.replayManager;
    const open = Boolean(anchorEl)

    const handleClose = useCallback(() => {
        setAnchorEl(null)
    }, [])

    const handleButtonClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }, [])

    return (
        <>
            <NonInteractiveTooltip title={'Replay speed'} arrow placement='top'>
                <ExtraSmallButton
                    ref={anchorRef}
                    data-event={'Replay Speed Menu Opened'}
                    onClick={handleButtonClick}
                    sx={{ minWidth: 44, width: 44 }}
                >
                    {speed}x
                </ExtraSmallButton>
            </NonInteractiveTooltip>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                container={container ? document.getElementById(MULTIPANE_FULLSCREEN_MODE_ID) : null}
                transitionDuration={0}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <CustomListSubheader>REPLAY SPEED</CustomListSubheader>
                {
                    replaySpeeds.map((s) => (
                        <MenuItem
                            sx={{ width: '210px' }}
                            selected={s === speed}
                            key={`${s}x`}
                            onClick={() => {
                                replayManager.setReplaySpeed(s)
                                setSpeed(s);
                                handleClose()
                            }}
                        >
                            <Stack width='100%' direction="row" sx={{ justifyContent: 'space-between' }}>
                                <span>{s}x</span><span>{s > 1 ? s : 1} upd per {s > 1 ? 1 : Math.floor(1 / s)} sec</span>
                            </Stack>
                        </MenuItem>
                    ))
                }
            </Menu>
        </>
    )
}

export default memo(ReplaySpeedMenu)